// extracted by mini-css-extract-plugin
export var fullHeightState = "_4j-7";
export var headerCell = "_4j-1";
export var loadingStateCell = "_4j-4";
export var rowWrapper = "_4j-3";
export var standaloneTable = "_4j-8";
export var standaloneTableWithBodyFill = "_4j-9";
export var stateCell = "_4j-5";
export var table = "_4j-0";
export var tableBodyFiller = "_4j-6";
export var white = "_4j-2";